import React from "react";
import {
  Form,
  Row,
  Col, Input, Button, Select, Icon
} from "antd";
import MiCompAPI from "./../../util/api";
import img from './../../assets/img/freepik  Plant  inject 2.png';
const {Option}=Select;

class FD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err && !this.state.isValuenameExists && !this.state.isValueEmailExists) {
        this.props.submitHandler({ ...values }, (val) => {
          if (!val) {
          }
        });
      } else {

      }
    });
  };
  componentDidMount = () => {

  };


  handleChangeEmailUser = (e) => {
    if (e.target.value && e.target.value.length > 4) {
      this.api.invoke("IsValueExists/USERS/" + e.target.value + "/EMAIL", "get", (data, success) => {
        if (success) {
          this.setState({ isValueEmailExists: data.data });
        }
      });
    }
  }
  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title' style={{ marginLeft: '8px' }}>Invite User
              <br></br>
              <span className='mi_title2'>Fill up the following form in order to invite a User</span>
            </p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" onClick={() => this.props.closeDrawerHandler()} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">First Name</legend>
                  {getFieldDecorator('first_Name', {
                    rules: [{ required: true, message: 'Please enter First Name' },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input className="mi_input" maxLength={40} type="text" placeholder="Enter First Name *  " />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Middle Name</legend>
                  {getFieldDecorator('middle_Name', {
                    rules: [{ required: false, message: 'Please enter Middle Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input className="mi_input" maxLength={40} type="text" placeholder="Enter Middle Name" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Last Name</legend>
                  {getFieldDecorator('last_Name', {
                    rules: [{ required: true, message: 'Please enter Last Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input className="mi_input" maxLength={40} type="text" placeholder="Enter Last Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Email</legend>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: 'Please enter email' }, {
                      type: 'email', message: 'The input is not valid E-mail!.',
                    }],
                  })(<Input className="mi_input" onChange={this.handleChangeEmailUser.bind(this)}  type="text" placeholder="Enter Email *" />)}
                </fieldset>
              </Form.Item>
              {this.state.isValueEmailExists ? <p style={{ color: "red", marginTop: '5px', marginLeft: '12px' }}>Email already exists</p> : ""}
            </Col> <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Entity Type</legend>
                  {getFieldDecorator('etype', {
                    rules: [{ required: true, message: 'Please select Entity Type' }]
                  })
                    (
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input" placeholder="Please Select *">
                        <Option value="A" key="A">Agency</Option>
                        <Option value="B" key="B">Broker</Option>
                      </Select>)
                    }
                </fieldset>
              </Form.Item>
              {this.state.isValueEmailExists ? <p style={{ color: "red", marginTop: '5px', marginLeft: '12px' }}>Email already exists</p> : ""}
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7}>
              <img alt="example" style={{ height: '60px', marginBottom: '-20px', float: 'left' }} src={img} />
            </Col>
            <Col span={5}>
              <Button className="mi_button_right submit-button" onClick={() => this.props.closeDrawerHandler()} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button htmlType="submit" className="submit-button" type="primary" >
                Submit
              </Button>
            </Col>
            <Col span={7}>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const BrokerInvitation = Form.create()(FD);
export default BrokerInvitation;
